import React from 'react';
import MusicAlbumReleaseStepsView from './MusicAlbumReleaseStepsView';
import MusicAlbumInfoReleaseView from './MusicAlbumInfoReleaseView';
import MusicAlbumCorrectionRequestView from './MusicAlbumCorrectionRequestView';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import ErrorMessage from '../../../common/components/ErrorMessage';
import { MusicAlbumArtistEntity, MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicComposerEntity, MusicEntity, MusicFeaturingArtistEntity, MusicLyricWriterEntity, MusicPerformanceRoleEntity, MusicProductionAndEngineeringRoleEntity } from '../../types/MusicEntityTypes';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

/**
 * 確認画面
 */
export default function MusicAlbumEditForm4View({
  musicAlbum,
  getErrors,
  onBack,
  onNext,
  onStep,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_artists: MusicAlbumArtistEntity[],
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity & {
        music_featuring_artists: MusicFeaturingArtistEntity[],
        music_lyric_writers: MusicLyricWriterEntity[],
        music_composers: MusicComposerEntity[],
        music_production_and_engineering_roles: MusicProductionAndEngineeringRoleEntity[],
        music_performance_roles: MusicPerformanceRoleEntity[],
      },
    })[],
  },
  getErrors: (name: 'id') => FieldValidationErrorsType,
  onBack: () => void,
  onNext: () => void,
  onStep: (callback: (musicAlbumId: number) => void) => void,
}) {
  const [corrected, setCorrected] = React.useState(false);

  return (
    <>
      <MusicAlbumReleaseStepsView
        step={4}
        musicAlbum={musicAlbum}
        onClick={(callback) => onStep(callback)}
      />
      <form className="music_list">
        <MusicAlbumInfoReleaseView musicAlbum={musicAlbum} />
        {musicAlbum.release_status === 5 && (
          <div className="form__body">
            <MusicAlbumCorrectionRequestView musicAlbum={musicAlbum} />
            <CustomCheckbox
              checked={corrected}
              setChecked={(checked) => setCorrected(checked)}
              validationErrors={{}}
            >
              修正しました
            </CustomCheckbox>
          </div>
        )}
        <ul>
          <li className="bt_up_info">
            なんと、申し込んだら修正や取り下げはできません。
            <br />
            あなたの集中力を発揮して、隅々までよーくお確かめください！
          </li>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
            <CustomButton type="default-split" disabled={!(musicAlbum.release_status !== 5 || corrected)} onClick={() => onNext()}>配信申込へ</CustomButton>
          </li>
        </ul>
        <div className="form__body">
          <ErrorMessage type="error" validationErrors={getErrors('id')} />
        </div>
      </form>
    </>
  );
}
